import { onError } from '@apollo/client/link/error';
var link = /*#__PURE__*/onError(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
    networkError = _ref.networkError,
    operation = _ref.operation;
  if (graphQLErrors) {
    graphQLErrors.forEach(function (_ref2) {
      var message = _ref2.message,
        locations = _ref2.locations,
        path = _ref2.path;
      console.error("[Graphql error]: Error in the ".concat(operation === null || operation === void 0 ? void 0 : operation.operationName, " operation.\nMessage: ").concat(message, ", Location: ").concat(locations ? JSON.stringify(locations) : locations, ", Path: ").concat(path));
    });
  }
  if (operation.operationName === 'createSocketSession') {}
  if (networkError) {
    console.error("[Network Error]: ".concat(networkError));
  }
});
export default link;